import { render, staticRenderFns } from "./AppealManageList.vue?vue&type=template&id=1da7dbf7&scoped=true&"
import script from "./AppealManageList.vue?vue&type=script&lang=js&"
export * from "./AppealManageList.vue?vue&type=script&lang=js&"
import style0 from "./AppealManageList.vue?vue&type=style&index=0&id=1da7dbf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da7dbf7",
  null
  
)

export default component.exports